import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53ba7154"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-items-length"]
const _hoisted_2 = { class: "g-home-block_footer" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_9388_78943)" }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "10",
      cy: "10",
      r: "10",
      fill: "white"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7 13.5101V6.48894C7.00016 6.40109 7.02599 6.3149 7.07479 6.2394C7.12359 6.1639 7.19356 6.10187 7.27736 6.0598C7.36117 6.01774 7.45573 5.99719 7.55113 6.00031C7.64653 6.00343 7.73927 6.03011 7.81962 6.07755L13.7549 9.58714C13.8301 9.63145 13.8919 9.69244 13.9347 9.7645C13.9776 9.83656 14 9.91738 14 9.99951C14 10.0816 13.9776 10.1625 13.9347 10.2345C13.8919 10.3066 13.8301 10.3676 13.7549 10.4119L7.81962 13.9225C7.73927 13.9699 7.64653 13.9966 7.55113 13.9997C7.45573 14.0028 7.36117 13.9823 7.27736 13.9402C7.19356 13.8981 7.12359 13.8361 7.07479 13.7606C7.02599 13.6851 7.00016 13.5989 7 13.5111V13.5101Z",
      fill: "#3C92FE"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_9388_78943" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "20",
        height: "20",
        fill: "white"
      })
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_course = _resolveComponent("course")!
  const _component_courses = _resolveComponent("courses")!
  const _component_ac_button = _resolveComponent("ac-button")!
  const _component_home_block = _resolveComponent("home-block")!

  return (_openBlock(), _createBlock(_component_home_block, {
    class: "g-home-block home-courses",
    "link-all": { name: 'home-courses' },
    "current-item-index": _ctx.navigation.currentIndex,
    "onNav:prev": _ctx.navigation.prev,
    "onNav:next": _ctx.navigation.next,
    "is-disabled-prev": _ctx.navigation.isDisabledPrev,
    "is-disabled-next": _ctx.navigation.isDisabledNext
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('myCourses')), 1)
    ]),
    body: _withCtx(() => [
      _createVNode(_component_courses, { onLoaded: _ctx.onLoaded }, {
        courses: _withCtx(({ courses }) => [
          _createElementVNode("div", {
            class: "g-home-block_wrapper",
            ref: "refContainer",
            onWheel: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigation.onScrollWrapper && _ctx.navigation.onScrollWrapper(...args))),
            "data-items-length": courses.length
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courses, (item) => {
              return (_openBlock(), _createBlock(_component_course, {
                key: item.stream.id,
                course: item.course,
                stream: item.stream,
                class: "home-courses_course g-home-block_item"
              }, null, 8, ["course", "stream"]))
            }), 128))
          ], 40, _hoisted_1)
        ]),
        _: 1
      }, 8, ["onLoaded"])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.isShowContinueTraining)
          ? (_openBlock(), _createBlock(_component_ac_button, {
              key: 0,
              class: "home-courses_continue",
              onClick: _ctx.onHandlerContinueTraining
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('continueTraining')), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["current-item-index", "onNav:prev", "onNav:next", "is-disabled-prev", "is-disabled-next"]))
}